<template>
  <div class="testlist">
    <Header></Header>
    <Title title="题库管理"></Title>
    <div class="contain_main">
      <div class="search" @keydown.enter="changepage(1)">
        <div class="search_item">
          <!-- <span>
            <span>编号:</span>
            <Input v-model="data.questionid" placeholder="请输入..." style="width:0.5rem"/>
          </span>-->
          <span>
            <span>题目名称:</span>
            <Input v-model="data.question" placeholder="请输入..." style="width:1rem"/>
          </span>
          <span>
            难易度：
            <Select v-model="data.questionlevel" style="width:60px">
              <Option value="all">全部</Option>
              <Option :value="1">易</Option>
              <Option :value="2">中</Option>
              <Option :value="3">难</Option>
            </Select>
          </span>
          <span>
            知识点：
            <Select v-model="data.questionpoint" filterable style="width:80px;display:inline-block">
              <Option value="all">全部</Option>
              <Option v-for="item in qplist" :key="item.qpid" :value="item.qpid">{{item.qptitle}}</Option>
            </Select>
          </span>
          <span>
            所属分类：
            <Cascader
              style="width:100px;display:inline-block"
              :data="questiontype"
              v-model="questionbasic"
            ></Cascader>
          </span>
          <span>
            题目类型：
            <Select v-model="data.questiontype" style="width:60px">
              <Option value="all">全部</Option>
              <Option :value="1">单选题</Option>
              <Option :value="2">多选题</Option>
              <Option :value="3">判断题</Option>
              <Option :value="4">填空题</Option>
              <Option :value="5">问答题</Option>
            </Select>
          </span>
          <div class="item">
            <div class="button" @click="changepage(1)">搜索</div>
          </div>
          <div class="item">
            <div class="button" @click="$router.push('/manage/issueadd')">添加考题</div>
          </div>
        </div>
      </div>
      <CheckboxGroup v-model="checkall">
        <div class="table">
          <table>
            <thead>
              <tr>
                <td>编号<sort keySort='questionid' :inkeySort="data.order" @sort="actSort"></sort></td>
                <td style="width:250px;">题目名称<sort keySort='question' :inkeySort="data.order" @sort="actSort"></sort></td>
                <td style="width:100px;">所属分类</td>
                <td>题目类型</td>
                <td style="width:150px;">知识点</td>
                <td>分值<sort keySort='questionscore' :inkeySort="data.order" @sort="actSort"></sort></td>
                <td>难度</td>
                <td>添加时间<sort keySort='questioncreatetime' :inkeySort="data.order" @sort="actSort"></sort></td>
                <td>操作</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in list" :key="item.questionid">
                <td>
                  <Checkbox :label="item.questionid"></Checkbox>
                </td>
                <td>
                  <Tooltip :content="item.question|toText" placement="top-start">
                    <span class="issue_question">{{item.question|toText}}</span>
                  </Tooltip>
                </td>
                <td>{{item.qbtitle}}</td>
                <td>{{item.qttitle}}</td>
                <td>{{item.qptitle}}</td>
                <td>{{item.questionscore}}</td>
                <td>{{item.questionlevel|issuetype}}</td>

                <td>{{item.questioncreatetime|formatetime}}</td>
                <td>
                  <button class="blue" @click="edit(item.questionid)">编辑</button>
                  <button class="red" @click="del(item.questionid)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CheckboxGroup>
      <div class style="text-align:right;margin-top:20px;">
        <div style="float:left;">
          <Checkbox @on-change="ischeckall">全选</Checkbox>
          <Button size="small" @click="delall" type="error">删除</Button>
        </div>
        <Page
          :total="total"
          @on-change="changepage"
          :current='data.page'
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
    </div>
    <div style="height:200px"></div>
    <toast @close="close" @success="success" :questionid="questionid" v-if="model"></toast>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import toast from "./issuedit";
import sort from '../../components/sort'
import { Question_index, Question_del } from "../../assets/js/api.js";
export default {
  name: "examlists",
  data() {
    return {
      list: [],
      model: false,
      questionid: null,
      data: {
        questionid: null, //	string	true	普通参数		试题编号
        questiontype: "all", //	string	true	普通参数		试题题型
        questionlevel: "all", //	string	true	普通参数		试题难度：1简单2中等3困难
        question: null, //	string	true	普通参数		题目名称
        questionpoint: "all",
        questionbasic: null,
        order:null,
        sort:null,
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      },
      questionbasic: [],
      total: null,
      checkall: []
    };
  },
  mounted() {
    this.getlist();
  },
  computed: {
    qplist() {
      return this.$store.state.qplist;
    },
    questiontype() {
      return this.$store.state.questiontype;
    }
  },
  filters: {
    // 1普通试卷2抽题试卷3随机试卷
    typed(value) {
      switch (value) {
        case 1:
          return "普通试卷";
        case 2:
          return "抽题试卷";
        case 3:
          return "随机试卷";
      }
    },
    issuetype(value) {
      switch (value) {
        case 1:
          return "易";
        case 2:
          return "中";
        case 3:
          return "难";
      }
    },
    toText(description) {
      var description = description.replace(/(\n)/g, "");
      description = description.replace(/(\t)/g, "");
      description = description.replace(/(\r)/g, "");
      description = description.replace(/<\/?[^>]*>/g, "");
      description = description.replace(/\s*/g, "");
      return description;
    }
  },
  components: {
    Header,
    Title,
    toast,
    sort
  },
  methods: {
    actSort(data){
      this.data.sort = data.status
      this.data.order = data.key
      this.getlist() 
    },
    ischeckall(data) {
      if (data) {
        this.checkall = this.list.map(item => {
          return item.questionid;
        });
      } else {
        this.checkall = [];
      }
    },
    delall() {
      this.del(this.checkall.join(","));
    },
    close() {
      this.model = false;
    },
    changepage(data) {
      this.data.page = data;
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.getlist();
    },
    getlist() {
      this.checkall = [];
      var data={}
      for (var item in this.data) {
        if (this.data[item] == "all") {
          data[item] = " ";
        }else{
          data[item] = this.data[item]
        }
      }
      if (this.questionbasic) {
        data.questionbasic = this.questionbasic.slice(-1)[0];
      }
      Question_index(data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
          return;
        }
        this.list = [];
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    edit(id) {
      this.questionid = id;
      this.model = true;
    },
    del(id) {
      if (!confirm("您确定要删除该信息？")) {
        return;
      }
      Question_del({ questionid: id }).then(res => {
        if (res.data.code == 200) {
          this.$Notice.success({ title: "成功提示", desc: "删除成功！" });
          this.getlist();
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    success() {
      this.close();
      this.getlist();
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.search .search_item .item {
  margin: 0 0.1rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
  text-align: center;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
  /* background: rgb(249, 249, 249); */
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  border-radius: 0.2rem;
  border: none;
  margin: 0 0.02rem;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
button.blue {
  color: #25b3f9;
  background: #d3f3fc;
}
button.pri {
  color: #e037ff;
  background: #fadfff;
}
button.orange {
  color: #ff8d13;
  background: #ffe2c4;
}
button.green {
  color: #36cd68;
  background: #cffade;
}
button.red {
  color: #ff3a68;
  background: #ffd6de;
}

</style>


// WEBPACK FOOTER //
// src/pages/issue/issuelist.vue